import React from "react";
// import banner from "../../assets/projects/businessreport_banner.jpg";
// import ss1 from "../../assets/screenshots/businessdailyworkflow.png";
// import ss2 from "../../assets/screenshots/financeflow.png";
// import ss3 from "../../assets/screenshots/salesflow.png";
// import ss4 from "../../assets/screenshots/operationflow.png";
// import ss5 from "../../assets/screenshots/ceoreport.png";
// import ss6 from "../../assets/screenshots/weeklyworkflow.png";
import banner from "../../assets/projects/dailybusinessreportbanner.png";
import ss1 from "../../assets/screenshots/dailybusinessreport/ss1.png"
import ss2 from "../../assets/screenshots/dailybusinessreport/ss2.png"
import ss3 from "../../assets/screenshots/dailybusinessreport/ss3.png"
import ss4 from "../../assets/screenshots/dailybusinessreport/ss4.png"
import ss5 from "../../assets/screenshots/dailybusinessreport/ss5.png"

const BusinessReportAutomationPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="Business Reporting Automation Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        Automated Business Reporting System
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
        The Automated Business Reporting System is an AI automation project that automatically collects,
        processes, and distributes daily and weekly business reports. Built using n8n and Airtable, this
        system gathers finance data, sales data, and operational data from Airtable, summarizes the
        information, and delivers structured reports to department heads and the CEO via Outlook email
        and Slack.
        <br /><br />
        The automation eliminates manual reporting work by scheduling workflows that retrieve business
        data, calculate summaries, detect anomalies, and distribute department-specific reports. Each
        department receives its own report, while the CEO receives a full company summary that merges
        finance, sales, and operations data into one consolidated report.
      </p>
    </section>

      {/* Live Demo */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ▶️ Live Demo
    </h2>
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow"
        src="https://www.youtube.com/embed/ZF7KWc2-jsQ"
        title="Automated Business Reporting System Demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Workflow automation that orchestrates data processing and report generation</li>
        <li><strong>Airtable:</strong> Stores all finance transactions, sales transactions, and operation logs</li>
        <li><strong>Outlook Email Integration:</strong> Sends automated reports to department heads and CEO</li>
        <li><strong>Slack Integration:</strong> Sends real-time business report notifications and alerts</li>
      </ul>
    </section>

    {/* Daily Report Automation */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        📊 Business Daily Report Automation (n8n)
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Daily scheduled workflow automatically triggers the reporting system</li>
        <li>Three department workflows are executed: finance, sales, and operations</li>
        <li>Each workflow retrieves relevant data from Airtable</li>
        <li>Data is summarized into daily performance reports</li>
        <li>Department-specific reports are sent to each department head</li>
        <li>Alert system detects abnormal conditions such as low profit</li>
        <li>Alerts are automatically sent to the responsible department head</li>
        <li>All department results are merged into a single executive report</li>
        <li>The final company report is sent to the CEO via Outlook and Slack</li>
      </ul>
    </section>

    {/* Department Workflows */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🏢 Department Data Processing Workflows
      </h2>

      <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Finance Data Workflow</h3>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Search finance transactions stored in Airtable</li>
        <li>Calculate total revenue, expenses, and profit</li>
        <li>Create a summarized finance daily record</li>
        <li>Send finance report to the Finance Head</li>
        <li>Trigger alert if profit is below a predefined threshold</li>
      </ul>

      <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Sales Data Workflow</h3>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Retrieve daily sales transactions from Airtable</li>
        <li>Calculate total sales volume and revenue</li>
        <li>Create summarized sales daily records</li>
        <li>Send the report to the Sales Head</li>
      </ul>

      <h3 className="text-2xl font-semibold mt-6 mb-2">🔹 Operation Data Workflow</h3>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Retrieve operation logs stored in Airtable</li>
        <li>Summarize operational activities and metrics</li>
        <li>Create an operations daily report</li>
        <li>Send report to the Operation Head</li>
      </ul>
    </section>

    {/* Weekly Report Automation */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        📅 Business Weekly Report Automation
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Weekly scheduled workflow triggers the reporting process</li>
        <li>Finance, Sales, and Operation workflows run using weekly data</li>
        <li>Weekly data is summarized into higher-level business insights</li>
        <li>Department heads receive weekly performance reports</li>
        <li>CEO receives a full company weekly report combining all departments</li>
        <li>Reports are sent automatically via Outlook email and Slack</li>
      </ul>
    </section>

    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>

      <div className="flex flex-col gap-6">
        <div>
          <p className="mb-2 font-medium">Project Architecture</p>
          <a href={banner} target="_blank" rel="noopener noreferrer">
            <img src={banner} alt="Project Architecture" className="w-full rounded-lg shadow" />
          </a>
        </div>
        <div>
          <p className="mb-2 font-medium">Business Daily Report Main Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Daily Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Result example — Daily report emails</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Finance Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Result example — Daily Slack report</p>
          <a href={ss3} target="_blank" rel="noopener noreferrer">
            <img src={ss3} alt="Sales Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

          <div>
          <p className="mb-2 font-medium">Result example — Weekly report emails</p>
          <a href={ss4} target="_blank" rel="noopener noreferrer">
            <img src={ss4} alt="Sales Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

          <div>
          <p className="mb-2 font-medium">Result example — Weekly Slack report</p>
          <a href={ss5} target="_blank" rel="noopener noreferrer">
            <img src={ss5} alt="Sales Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

      </div>
    </section>

  </main>
);

export default BusinessReportAutomationPage;
